import { useMemo } from 'react';
import { costFormater, Option } from '@common-fe/common-fe';
import { toNumber, uniqBy } from 'lodash';

import { useDocumentOcrStore } from '@/modules/UseMyMoney/stores';

const MAX_AMOUNT_OPTIONS = 3;

interface Props {
  amount?: string;
}

const useAmountOptions = ({ amount }: Props) => {
  const { ocrDocument } = useDocumentOcrStore();

  const suggestedAmounts = useMemo(() => {
    if (!ocrDocument?.amountOptions?.length) {
      return [];
    }
    const filteredAmounts = ocrDocument?.amountOptions?.filter((amount) => !!amount?.isSuggested && !!amount?.amount);
    const uniqAmounts = uniqBy(filteredAmounts, 'amount');
    return uniqAmounts;
  }, [ocrDocument?.amountOptions]);

  const suggestedAmountOptions = useMemo((): Option<string>[] => {
    const options = suggestedAmounts?.slice(0, MAX_AMOUNT_OPTIONS)?.map((amountOption): Option<string> => ({
      key: amountOption?.amount,
      title: `${costFormater(toNumber(amountOption?.amount), true)}`,
      value: amountOption?.amount,
    }));
    return options;
  }, [suggestedAmounts]);

  const selectedAmountFromSuggested = useMemo(() => suggestedAmounts
    ?.find((amountOption) => {
      if (!amountOption?.amount || !amount) {
        return false;
      }
      return amountOption?.amount === amount;
    }),
    [amount, suggestedAmounts]);

  return {
    suggestedAmountOptions,
    selectedAmountFromSuggested,
  };
};

export default useAmountOptions;
